import { buildDashboardStats, buildKpiSeries, buildOpenedAccountsSeries } from '../fixtures/reports';

export default [
  {
    method: 'GET',
    pattern: /^\/customer-ms\/api\/v1\/statistics\/stat-and-kpi$/,
    handler: () => buildDashboardStats(),
  },
  {
    method: 'GET',
    pattern: /^\/customer-ms\/api\/v1\/statistics\/opened-account$/,
    handler: () => buildOpenedAccountsSeries(),
  },
  {
    method: 'GET',
    pattern: /^\/customer-ms\/api\/v1\/statistics\/kpi$/,
    handler: ({ params }) => buildKpiSeries(params.kpiType),
  },
];
